import { App } from 'vue';
import resourceHelper from '@/Utils/resourceHelper';

export default {
  install(app: App) {
    app.config.globalProperties.$localize = resourceHelper.getString;
  }
};
